/**
 * Central Production Site & SEO Configuration for JobMatch NG
 * Canonical Production Domain: https://jobmatch.ng
 */

export const SITE_CONFIG = {
  name: 'JobMatch NG',
  shortName: 'JobMatch',
  legalName: 'JobMatch NG Technologies Limited',
  domain: 'jobmatch.ng',
  productionUrl: 'https://jobmatch.ng',
  supportEmail: 'support@jobmatch.ng',
  telegramBotUsername: 'JobMatchNG_AIAssistant_bot',
  defaultLocale: 'en_NG',
  defaultThemeColor: '#059669', // Emerald-600

  // Primary SEO Metadata
  defaultTitle: 'JobMatch NG | Verified Artisans & Technicians in Nigeria',
  titleTemplate: '%s | JobMatch NG',
  defaultDescription:
    'Hire verified plumbers, electricians, AC technicians, generator mechanics, and skilled artisans across Nigeria. Post repair jobs and compare quotes in Naira.',
  defaultOgDescription:
    'Hire verified plumbers, electricians, AC technicians, generator mechanics, and skilled artisans across Nigeria with JobMatch NG.',

  // Social Share Assets
  defaultOgImage: 'https://jobmatch.ng/og-image.png',
  defaultOgImageWidth: '1200',
  defaultOgImageHeight: '630',
  defaultOgImageAlt: 'JobMatch NG connects customers with skilled professionals across Nigeria.',
  logoUrl: 'https://jobmatch.ng/assets/jobmatch-logo.png',
  faviconUrl: 'https://jobmatch.ng/favicon.ico',

  // Google Search Console Verification Environment Key
  googleSiteVerificationEnvKey: 'GOOGLE_SITE_VERIFICATION',

  // Keywords & Search Queries
  keywords: [
    'JobMatch',
    'JobMatch NG',
    'JobMatch Nigeria',
    'find artisans in Nigeria',
    'find verified artisans Nigeria',
    'hire artisans Nigeria',
    'find professionals Nigeria',
    'plumbers in Nigeria',
    'electricians in Nigeria',
    'auto mechanics in Nigeria',
    'car mechanic Nigeria',
    'carpenters in Nigeria',
    'home repair services Nigeria',
    'local professionals Nigeria',
    'generator repair Nigeria',
    'AC technician Lagos Abuja',
  ],
} as const;

/**
 * Returns the base site URL, prioritizing configured environment variables,
 * defaulting strictly to https://jobmatch.ng in production.
 */
export function getSiteUrl(): string {
  // Client-side environment resolution
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (host === 'jobmatch.ng' || host === 'www.jobmatch.ng') {
      return SITE_CONFIG.productionUrl;
    }
    // Allow localhost during active local development
    if (host === 'localhost' || host === '127.0.0.1') {
      return `${window.location.protocol}//${window.location.host}`;
    }
    // Preview / Cloud Run deployment URLs
    return `${window.location.protocol}//${window.location.host}`;
  }

  // Server-side fallback
  const envUrl = (
    process.env.VITE_SITE_URL ||
    process.env.SITE_URL ||
    process.env.APP_URL ||
    process.env.PUBLIC_URL ||
    ''
  ).trim().replace(/^["']|["']$/g, '');

  if (envUrl && /^https?:\/\//i.test(envUrl)) {
    return envUrl.replace(/\/+$/, '');
  }

  return SITE_CONFIG.productionUrl;
}
